import { loadStripe } from '@stripe/stripe-js/pure'
import type { Stripe } from '@stripe/stripe-js'

const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
const connectedAccountId = import.meta.env.VITE_STRIPE_CONNECTED_ACCOUNT_ID

if (!publishableKey) {
  throw new Error('VITE_STRIPE_PUBLISHABLE_KEY is required.')
}
if (!connectedAccountId?.startsWith('acct_')) {
  throw new Error('VITE_STRIPE_CONNECTED_ACCOUNT_ID must be a Stripe account ID.')
}

/**
 * All site payment Elements operate as the One Day Dance connected account.
 * This must match the account used by the Cloud Function that creates the
 * corresponding direct-charge PaymentIntent.
 */
let stripePromise: Promise<Stripe | null> | null = null

/**
 * Load Stripe only after a visitor enters a payment flow. Besides reducing
 * work on ordinary pages, this keeps Stripe's fraud-prevention storage scoped
 * to a service the visitor explicitly requested.
 */
export function getStripePromise(): Promise<Stripe | null> {
  stripePromise ??= loadStripe(publishableKey, {
    stripeAccount: connectedAccountId,
  })
  return stripePromise
}
